import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M19.5 6.5c-4-5-9.057-3.486-10.653-2.637C5.6 5.559 3.92 8.982 4.003 12.784 4.115 16.792 7 20 11.001 20.5c7 1.5 12-6 9-6.5-2.15-.358-4 2.5 1.5 4"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M15.274 11.79a2.518 2.518 0 1 1-5.019.421 2.518 2.518 0 0 1 5.02-.422"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      d="M12.817 12.62c.324-.028.61-.339.568-.673-.044-.334-.325-.597-.673-.568-.324.027-.611.339-.568.673s.325.597.672.568"
      style={{
        fill: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m12.554 9.49-.106-1.255M10.255 12.21 9 12.315M12.975 14.51l.106 1.255M15.274 11.79l1.255-.106"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m3 13.231 2.753-.23M12 2l.232 2.752M13.676 21.93l-.232-2.753"
    />
  </svg>
);
export const TargetIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
